import { Link, NavLink } from 'react-router-dom';
import styles from './GeneralNavigation.module.css';
import { useState } from 'react';
import { RiArrowDropDownLine } from 'react-icons/ri';
import { FaAngleDown } from 'react-icons/fa6';

const GeneralNavigation = ({}) => {
  const [dropdownVisible, setDropdownVisible] = useState(false);

  const toggleDropdown = () => {
    setDropdownVisible(!dropdownVisible);
  };

  return (
    <>
      <div className={styles.dropDown}>
        <button onClick={toggleDropdown} className={styles.dropBtn}>
          Terms <FaAngleDown size={16} />
        </button>
        {dropdownVisible && (
          <div className={styles.dropDownContent}>
            <NavLink to="/info/terms-and-conditions">Terms</NavLink>
            <NavLink to="/info/privacy-policy">Privacy Policy</NavLink>
            <NavLink to="/info/refund-policy">Refund Policy</NavLink>
            <NavLink to="/info/partnership">Partnership</NavLink>
          </div>
        )}
      </div>
      <div className={styles.dropDown}>
        <button onClick={toggleDropdown} className={styles.dropBtn}>
          Services <FaAngleDown size={16} />
        </button>
        {dropdownVisible && (
          <div className={styles.dropDownContent}>
            <Link to="/costs-and-prices">Costs and Prices</Link>
            <Link to="/gift-delivering">Gift Delivering</Link>
            <Link to="/live-chat-service">Live Chat</Link>
            <Link to="/online-dating-service">Online Dating</Link>
          </div>
        )}
      </div>

      <Link className={styles.contactUsLink} to="/info/contact-us">
        Contact Us
      </Link>
      <Link className={styles.aboutUsLink} to="/info/about-us">
        About Us
      </Link>

      <Link className={styles.signUpLink} to="/sign-up">
        <button className={styles.signUpBtn}>Sign Up</button>
      </Link>
    </>
  );
};

export default GeneralNavigation;
